/**
 * Regex to parse value with optional px or em units
 */
export const RGX = /(-*\d*[.,]*\d*)(px|em)*/;
